module.exports = __webpack_public_path__ + "static/media/ic_delete.d53b273f.png";